import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const ConversationIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
			ref={ref}
			{...props}
		>
			<path
				fill="currentColor"
				d="M5 7.7083C5 8.79202 5.87944 9.67054 6.96429 9.67054H9.12566L11.8019 11.8766C12.1513 12.1646 12.6786 11.9163 12.6786 11.4638V9.67054H13.0357C14.1206 9.67054 15 8.79202 15 7.7083V3.96223C15 2.87852 14.1206 2 13.0357 2H6.96429C5.87944 2 5 2.87852 5 3.96223V7.7083Z"
			></path>
			<path
				fill="currentColor"
				d="M8.76663 10.6705H6.96429C5.32814 10.6705 4 9.34529 4 7.7083V4H2.96429C1.87944 4 1 4.87852 1 5.96223V9.7083C1 10.792 1.87944 11.6705 2.96429 11.6705H3.32143V13.4638C3.32143 13.9163 3.84871 14.1646 4.19811 13.8766L6.87434 11.6705H9.03571C9.30499 11.6705 9.56161 11.6164 9.79526 11.5185L8.76663 10.6705Z"
			></path>
		</svg>
	),
)
